export default __webpack_public_path__ + "static/media/profile-user.983be362.svg";